export const stopKeyboardEventPropagation = (
  e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
): void => {
  const allowedPropagationKeys = [
    'ArrowUp',
    'ArrowDown',
    'Enter',
    'Tab',
    'Delete',
    'Backspace',
    'Alt',
    'Control',
    'Meta',
    'Escape',
  ];
  if (!allowedPropagationKeys.includes(e.key)) {
    e.stopPropagation();
  }
};
